import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-tinypreloader',
  templateUrl: './tinypreloader.component.html',
  styleUrls: ['./tinypreloader.component.scss']
})
export class TinypreloaderComponent implements OnInit {

  @Input()
  isSearching = false;


  constructor(
  ) { }

  ngOnInit(): void {
  }

}
